/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-09-14 15:04:01
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-03-15 14:39:10
 */
import Vue from "vue";
import Component from "./ContactPicker.vue";

const Constructor = Vue.extend(Component);

// const instances = [];
let seed = 1;

const ContactPicker = options => {
  if (Vue.prototype.$isServer) return;
  const {
    //autoClose,
    ...rest
  } = options;
  const instance = new Constructor({
    propsData: {
      ...rest
    },
    data: {
      //autoClose: autoClose === undefined ? 3000 : autoClose
    }
  });

  const id = `ContactPicker_${seed++}`;
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;

  //绑定 change 方法
  instance.vm.$on("change", selecteds => {
    if (instance.change) {
      instance.change(selecteds);
    }
  });
  // instance.vm.$on("destroy", () => {
  //   document.body.removeChild(instance.vm.$el);
  // });
  return instance.vm;
};

export default ContactPicker;
